import React from 'react';
import { NavItem } from '../../framework/nav/NavItem';
import EntryPoints from '../../framework/nav/EntryPoints';
import { motion } from "motion/react";
import { Accordion } from 'react-bootstrap';

const logo = 'https://i.postimg.cc/nhb9pXs0/Unsplash-For-Confluence.png';

const UnsplashView = () => {

  const renderUnsplashSiteLink = (): any => {
    return (
      <a href='https://www.unsplash.com' target='_blank' rel="noreferrer">Unsplash</a>
    );
  };

  return (
    <div>
        <div className="itemLeft">
        <title>Unsplash for Confluence</title>
          <div className="app-title">
            <img className="logo-img" src={logo} alt="Unsplash for Confluence logo"></img>
            <h1>Unsplash for Confluence</h1>
          </div>

          <h2>Summary</h2>
          <p>
            Add amazing photos from {renderUnsplashSiteLink()} to your Confluence pages. Leverage the creative efforts 
            of millions of photographers and creative professionals around the world without any licensing restrictions.
          </p>
          <a href="https://marketplace.atlassian.com/apps/1236708?tab=overview&hosting=cloud">View Here</a>
          <br></br><br></br>
        </div>

        <Accordion defaultActiveKey="0" className="accordianContainer">
          <Accordion.Item eventKey="0">
            <Accordion.Header>Support</Accordion.Header>
            <Accordion.Body>
              <div className="accordionBody">
                <p>
                  {renderUnsplashSiteLink()} is an enormous repository of high quality photos from photographers and creative 
                  people all around the world. Now, with Unsplash for Confluence, you can easily use stunning photos to get your 
                  point across and make your page stand out. 

                  Choose from a variety of formatting options to suit your desired presentation style.
                  
                  Any photo from {renderUnsplashSiteLink()} can be selected without any licensing restrictions. 
                  
                  Unsplash for Confluence does not egress any data, nor does it store any user information, including cookies.
                </p>
              </div>
              <div>
                <h2>Support</h2>
                <h3>Support Request</h3>
                <p>
                  For any support requests, please fill out <a href='https://docs.google.com/forms/d/e/1FAIpQLSeO-jVhQRqf7lF0WEhtmGy4p1TzN8TIdfldQL5jjzXxC8uO3g/viewform?usp=header'>this form</a>.
                </p>
                <h3>Where it is Supported</h3>
                <p>
                  The Atlassian marketplace application is available for any Confluence document, granted the document owner has given
                  permission for the app to be installed.
                </p>
                <h3>Language Support</h3>
                <p>Only English is supported, however this will be expanded in future updates. Languages of any URL's are supported however,
                  as well as any language titles or descriptions (Supported by UTF-8).
                </p>
                <h3>Software Updates</h3>
                <p>
                  Regular software updates will be made to improve functionality and eliminate bugs.
                </p>
                {/* <a href='https://lucamorrow.com/#unsplash-for-confluence-privacy'>See Privacy Policy Here</a>
                <br></br>
                <a href='https://lucamorrow.com/#unsplash-for-confluence-user-guide'>See User Guide Here</a> */}
              </div>
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="1">
            <Accordion.Header>Privacy</Accordion.Header>
            <Accordion.Body>
              <div className="accordionBody">
                <p>No data of any form is collected by the application at any point in time.</p>
                <p><a href='https://www.iubenda.com/privacy-policy/58296545'>Click here</a> to view a full copy of the Privacy Policy of Unsplash for Confluence</p>
                <br></br>
                <h1>End User License Agreement of Unsplash for Confluence</h1>
                <p>This End User License Agreement governs the use of the application in a legally binding way. You must read this document carefully.</p>
                <p>The application is provided by:</p>
                <p>Luca Morrow</p>
                <p><strong>Contact email:</strong> luca@iconic.com.au</p>

                <h2>What you should know at a glance</h2>
                <p>Please note that some provisions may only apply to certain categories of users. In particular, certain provisions may only apply to consumers or to those users that do not qualify as consumers. Such limitations are always explicitly mentioned within each affected clause. In the absence of any such mention, clauses apply to all users.</p>

                <h2>TERMS OF USE</h2>
                <p>Unless stated otherwise, the terms in this section apply generally when using our application.</p>
                <p>Specific or additional conditions may apply in certain situations and are noted in this document.</p>

                <h3>Content on this application</h3>
                <p>Unless otherwise noted, all content on our application is owned or provided by us or our licensors.</p>
                <p>We do our best to ensure the content on our application complies with all laws and respects third-party rights. However, this may not always be achievable. If you believe your rights are being infringed, without prejudice to any legal prerogatives to enforce your rights, please report any issues using the contact details provided in this document.</p>

                <h4>Removal of content from parts of this application available through the Atlassian Marketplace</h4>
                <p>If the reported content is deemed objectionable, it will be removed and those who provided the content will be prevented from using our application.</p>

                <h3>Access to external resources</h3>
                <p>Our application may contain links to external resources provided by third parties. We do not control these resources and are not responsible for their content or availability. You should review the terms and conditions of any external resources you access through our application.</p>
              </div>
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="2">
            <Accordion.Header>Installation</Accordion.Header>
            <Accordion.Body>
              <div className="accordionBody">
                <ol>
                  <li>Log into your instance of Confluence as an admin</li>
                  <li>Click on <a href="https://marketplace.atlassian.com/apps/1236708?tab=overview&hosting=cloud">this link</a> or navigate to the Atlassian marketplace and search for <b>'Unsplash for Confluence'</b></li>
                  <li>Click <b>'Get it now'</b></li>
                  <li>Once the app is installed, you will be notified via a success message. Following which, you can start using the app</li>
                </ol>
                
                <h2>How to use</h2>
                <h3>Adding the macro</h3>
                <ul>
                  <li>Once the application has been installed, simply open the desired confluence document, go into edit mode and click on the section in the document where you would like to place the macro</li>
                  <li className="beforeIndentedLi">Then, either:</li>
                  <ul>
                    <li className="indentedLi">Type: '/Photo from Unsplash'</li>
                    <li className="beforeIndentedLi">OR</li>
                    <li className="indentedLi">Click on the '+' icon at the right of the toolbar at the top of the page and search for 'Photo from Unsplash'</li>
                  </ul>
                  <li>The options 'Photo from Unsplash (block layout)' and 'Photo from Unsplash (inline layout)' should appear from the dropdown menu. Choose one and select it to embed the macro into the document.</li>
                </ul>

                <br/>
                <h3>Using the macro</h3>
                <p>
                  Search for an image to insert into the Confluence document by typing in a keyword into the search bar. Once you have found an image you like, click on it to insert it into the document.
                </p>
                <br/>
                <p>Click <a href="https://drive.google.com/file/d/1sBfjhGpCgrMJkBFcqPBaPjZ-hWEGX-F6/view">here</a> for a more detailed guide.</p>
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>

      </div>
    );
};

class UnsplashPrivacyEntryPoints implements EntryPoints {

  renderFullView = (navItem: NavItem, secondaryNavItems: string[], width: number, height: number): any => {
    return <UnsplashView />;
  }

  renderIntroView = (navItem: NavItem, secondaryNavItems: string[]): any => {
    return (
      <span>Unsplash intro</span>
    );
  }

}

const unsplashPrivacyEntryPoints = new UnsplashPrivacyEntryPoints();
export default unsplashPrivacyEntryPoints;
